/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowElbowRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M240,80v72a8.00053,8.00053,0,0,1-13.65723,5.65723L196,127.31445l-70.34277,70.34278a8.00181,8.00181,0,0,1-11.31446,0l-96-96A8.00053,8.00053,0,0,1,29.65723,90.34277L120,180.68652l64.68579-64.68628-30.343-30.343A8.00065,8.00065,0,0,1,160,72h72A8.00039,8.00039,0,0,1,240,80Z" />
    </Svg>
  );
}

export default ArrowElbowRight;
